import React from 'react';

import type { CliveConfigTableSwitchColumnConfig } from '../../CliveConfiguration/CliveConfigurationTable';
import CliveConfigTable from '../../CliveConfiguration/CliveConfigurationTable';

const SWITCH_COLUMNS_CONFIG: CliveConfigTableSwitchColumnConfig[] = [
  {
    id: 'use_demo_fnol_policy_search',
    label: 'Demo FNOL Policy Search',
  },
  {
    id: 'use_demo_fnol_email_processing',
    label: 'Demo FNOL Email Processing',
  },
  {
    id: 'demo_acknowledgement_letter_action',
    label: 'Demo Acknowledgement Letter Action',
  },
  {
    id: 'demo_adjuster_assignment_action',
    label: 'Demo Adjuster Assignment Action',
  },
];

const CliveDemoManagementTab: React.FC = () => {
  return <CliveConfigTable config_switch_columns={SWITCH_COLUMNS_CONFIG} />;
};

export default CliveDemoManagementTab;
